<template>
    <div class="c-left" :class="{ show }" v-clickoutside="close">
        <div class="show-btn" @click="show = true" v-if="!show">
            <i class="el-icon-arrow-right"></i>
        </div>
        <div class="add-btn" @click="clickMenu(null)">
            <i class="el-icon-plus"></i>
            新建对话
        </div>
        <div class="list">
            <div class="list-item" :class="{ active: item == activeItem }" v-for="(item, index) in menuList" :key="index"
                @click="clickMenu(item)">
                <div class="editinput" v-if="item.edit" @click.stop="">
                    <el-input v-model="title"></el-input>
                    <span class="btn-g">
                        <i class="el-icon-check" @click.stop="submit(item)"></i>
                        <i class="el-icon-close" @click.stop="item.edit = false"></i>
                    </span>
                </div>
                <template v-else>
                    <div class="title-bl">
                        <i class="el-icon-chat-square"></i>
                        <span class="title">
                            {{ item.sessionTitle }}
                        </span>
                    </div>
                    <span class="btn-g">
                        <i class="el-icon-edit" @click.stop="edit(item)"></i>
                        <i class="el-icon-delete" @click.stop="delData(item, index)"></i>
                    </span>
                </template>
            </div>
        </div>
        <div class="del-btn" @click="delAll">
            <i class="el-icon-delete"></i>
            清除所有对话
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            menuList: [],
            title: "",
            activeItem: {},
            editItem: {},
        }
    },
    methods: {
        close() {
            this.show = false;
        },
        submit(item) {
            let obj = {
                sessionId: item.sessionId, // 会话Id 
                sessionTitle: this.title,
                sessionJson: item.sessionJson, // 会话JSON  
            }
            this.$store.commit("showLoading")
            this.api("saveChatGptSessionHistory", obj).then(res => {
                this.$store.commit("hideLoading")
                this.$message.success(res.msg)
                item.sessionTitle = this.title;
                item.edit = false;
            })
        },
        clickMenu(item) {
            this.activeItem = item || {}
            this.$emit("change", this.activeItem);
            this.show = false;
        },
        edit(item) {
            this.menuList.forEach(i => i.edit = false);
            this.editItem = item;
            item.edit = true;
            this.title = item.sessionTitle;
        },
        delAll() {
            this.$confirm("确定要删除全部会话吗？", "提示").then(() => {
                let obj = {
                    isAll: 1, //	是否删除所有 0否 1是
                }
                this.$store.commit("showLoading")
                this.api("deleteChatGptSessionHistory", obj).then((res) => {
                    this.$store.commit("hideLoading")
                    this.$message.success(res.result)
                    this.menuList = []
                    this.clickMenu()
                })
            })
        },
        delData(item, index) {
            this.$confirm("确定要删除吗？", "提示").then(() => {
                let obj = {
                    isAll: 0, //	是否删除所有 0否 1是
                    sessionId: item.sessionId, //	会话Id
                }
                this.$store.commit("showLoading")
                this.api("deleteChatGptSessionHistory", obj).then(res => {
                    this.$store.commit("hideLoading")
                    this.$message.success(res.result)
                    this.menuList.splice(index, 1)
                    if (this.activeItem == item) {
                        this.clickMenu()
                    }
                })
            })
        },
        saveData(res) {
            let obj = {
                sessionId: res.sessionId, // 会话Id 
                sessionTitle: res.sessionTitle, // 会话标题 
                sessionJson: res.sessionJson, // 会话JSON 
            }
            this.$store.commit("showLoading")
            this.api("saveChatGptSessionHistory", obj).then(res => {
                this.$store.commit("hideLoading")
                this.menuList = res.result.sessionId;
            })
        },
        getData() {
            let obj = {
                "pageSize": 1000,
                "pageIndex": 1
            }
            this.$store.commit("showLoading")
            this.api("listChatGptSessionHistory", obj).then(res => {
                this.$store.commit("hideLoading")
                this.menuList = res.result.map(i => {
                    i.edit = false;
                    return i
                });
                this.setActive();
            })
        },
        // 如果有缓存数据 设置相应菜单的高亮显视
        setActive() {
            let getSave = localStorage.getItem("menuInfo")
            if (getSave) {
                getSave = JSON.parse(getSave);
                this.activeItem =  this.menuList.find(i=>i.sessionId == getSave.menuInfo.sessionId )
            }
        }
    },
    created() {
        this.getData();
    },

}
</script>

<style lang="scss" scoped></style>